import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './instructions.css';
import Button from './button';

const Instructions = ({
  className,
  backgroundImage,
  title,
  text,
  onStart
}) => {
  const overlayRef = useRef(null);
  const panelRef = useRef(null);
  const exitingRef = useRef(false);

  useEffect(() => {
    const content = panelRef.current.querySelectorAll(
      '.instructions_title, .instruction_text, .instructions_start_button'
    );
    const timeline = gsap.timeline();

    timeline.fromTo(
      panelRef.current,
      {
        opacity: 0,
        y: 44,
        scale: 0.9
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.58,
        ease: 'back.out(1.2)'
      }
    );

    timeline.fromTo(
      content,
      {
        opacity: 0,
        y: 12
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.34,
        stagger: 0.07,
        ease: 'power2.out'
      },
      '-=0.2'
    );

    return () => timeline.kill();
  }, []);

  const startLevel = () => {
    if (exitingRef.current) return;

    exitingRef.current = true;

    const timeline = gsap.timeline({ onComplete: onStart });

    timeline.to(panelRef.current, {
      opacity: 0,
      y: -28,
      scale: 0.92,
      duration: 0.32,
      ease: 'power2.in'
    });

    timeline.to(
      overlayRef.current,
      {
        opacity: 0,
        duration: 0.2,
        ease: 'power2.in'
      },
      '<'
    );
  };

  return (
    <div
      ref={overlayRef}
      className={`instructions_overlay ${className}_overlay`}
    >
      <div
        ref={panelRef}
        className={`instructions_panel ${className}_panel`}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <h1 className="instructions_title">{title}</h1>

        {text.map((instruction, index) => (
          <p
            className={`instruction_text instruction_text_${index + 1}`}
            key={instruction}
          >
            {instruction}
          </p>
        ))}

        <Button
          className={`instructions_start_button ${className}_start_button`}
          onclick={startLevel}
        >
          Start
        </Button>
      </div>
    </div>
  );
};

export default Instructions;
